import { render, staticRenderFns } from "./Richtext.vue?vue&type=template&id=334c5bed&scoped=true&"
import script from "./Richtext.vue?vue&type=script&lang=js&"
export * from "./Richtext.vue?vue&type=script&lang=js&"
import style0 from "./Richtext.vue?vue&type=style&index=0&id=334c5bed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334c5bed",
  null
  
)

export default component.exports